export default __webpack_public_path__ + "static/media/Rectangle.ccb7a000.png";